// App.tsx
import React from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { Provider } from "react-redux";
import { store } from "./api";
import ChatContext from "./components/MSRContext";
import { useCheckSubdomain } from "./hooks/useCheckSubdomain";
import NotFoundPage from "./components/NotFoundPage";
import { UnreadDividerProvider } from "./context/UnreadDividerContext";
import { SelectedCompanyProvider } from "./context/SelectedCompanyContext";

export default function App() {
  const domainValid = useCheckSubdomain();

  if (domainValid === null) {
    return <div className="mt-20 text-center text-gray-500">Loading...</div>;
  }

  if (domainValid === false) {
    return <NotFoundPage message="Corporate domain not found." />;
  }

  return (
    <Provider store={store}>
      <SelectedCompanyProvider>
        <UnreadDividerProvider>
          <ChatContext>
            <RouterProvider router={router} />
          </ChatContext>
        </UnreadDividerProvider>
      </SelectedCompanyProvider>
    </Provider>
  );
}
